import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVolumeMinimum: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="volume-minimum, speaker, loud, sound"><path d="M15.4648 10C15.8052 10.5884 16 11.2715 16 12.0001C16 12.7287 15.8052 13.4118 15.4648 14.0001M1.75 7.75H6L12.25 4.25V19.75L6 16.25H1.75V7.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconVolumeMinimum;
